import React, { createContext, useContext, useEffect, useState } from 'react'
import axiosInstance from '../utils/RequestsQueue'; // Adjust the path as needed
import {  useNavigate } from 'react-router-dom';
import {showSwalNotification} from '../utils/SwalResponse';
// import { StatsContext } from '../stats/StatsContext';

export const AuthContext = createContext()
export default function AuthProvider({children}) {
  // const { fetchStats }= useContext(StatsContext)
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    // const location = useLocation()
    const [allAdmins, setAllAdmins] = useState([])

    // ===================== AUTHTOKEN LOGIC =================
    const [authToken, setAuthTokenState] = useState(() => localStorage.getItem('MazGuardAuthToken') ? localStorage.getItem('MazGuardAuthToken') : null);
    const setAuthToken = (token) => {
        localStorage.setItem('MazGuardAuthToken', token);
        setAuthTokenState(token);
    };

    // ===================== CURRENT USER LOGIC =================
    
  const [currentUser, setCurrentUserState] = useState(() => sessionStorage.getItem('MazGuardCurrentUser') ? JSON.parse(sessionStorage.getItem('MazGuardCurrentUser')) : null);
    // Update currentUser in session storage and state
  const setCurrentUser = (user) => {
    sessionStorage.setItem('MazGuardCurrentUser', JSON.stringify(user));
    setCurrentUserState(user);
  };

  // VAIDATE ADMIN 
  // useEffect(() => {
  //   const checkAdminPath = () => {
  //     if (location.pathname.toLowerCase().includes('admin') && currentUser?.user_type !== 'admin') {
  //       // console.log('Not Admin ');
  //       navigate('/')
  //     }
  //   };

  //   checkAdminPath();
  // }, [location.pathname,currentUser]);




      // ================== REGISTER SPECIALIST (ADMIN) ================    
      async function specialistRegistration(formData){
        if (!!formData && !!authToken){
            try {
                setLoading(true)
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/register-admin`,
                  method:"POST",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`
                  },
                  data: formData
                })
                // console.log('Response:',response?.data)
                if (response?.data?.status === 'success'){
                  // setAuthToken(response?.data?.data?.token);
                  fetchAllAdmins()
                }
                return response?.data 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                
              return error.response.data
            } finally{
              setLoading(false)
            }
        }
      }




      // ==================REGISTER================    
      async function userRegistration(formData){
        if (!!formData){
            try {
                setLoading(true)
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/register`,
                  method:"POST",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    // Authorization: `Bearer ${authToken}`
                  },
                  data: formData
                })
                // console.log('Response:',response?.data)
                if (response?.data?.status === 'success'){
                  setAuthToken(response?.data?.data?.token);
                }
                return response?.data 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                
              return error.response.data
            } finally{
              setLoading(false)
            }
        }
      }



      // ==================LOGIN================    
      async function userLogin(formData){
        if (!!formData){
            try {
                setLoading(true)
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/login`,
                  method:"POST",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    // Authorization: `Bearer ${authToken}`
                  },
                  data: formData
                })
                // console.log('Response:',response?.data)
                if (response?.data?.status === 'success'){
                  setAuthToken(response?.data?.data?.token);
                }
                return response?.data 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                
              return error.response.data
            } finally{
              setLoading(false)
            }
        }
      }
      // ==================GOOGLE LOGIN================    
      async function userGoogleLogin(formData){
        if (!!formData){
            try {
                setLoading(true)
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/google-login`,
                  method:"POST",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    // Authorization: `Bearer ${authToken}`
                  },
                  data: formData
                })
                // console.log('Response:',response?.data)
                if (response?.data?.status === 'success'){
                  setAuthToken(response?.data?.data?.token);
                }
                return response?.data 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                
              return error.response.data
            } finally{
              setLoading(false)
            }
        }
      }

      // ==================VERIFY ADMIN================    
      async function adminLoginVerification(formData){
        if (!!formData){
            try {
                setLoading(true)
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/verify`,
                  method:"POST",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    // Authorization: `Bearer ${authToken}`
                  },
                  data: formData
                })
                // console.log('Response:',response?.data)
                if (response?.data?.status === 'success'){
                  setAuthToken(response?.data?.data?.token);
                  // fetchStats()
                }
                return response?.data 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                
              return error.response.data
            } finally{
              setLoading(false)
            }
        }
      }

    // ==================LOGOUT================
    

    async function userLogout(){
      if (authToken){
          try {
              setLoading(true)
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/logout`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                // data:{password}
              })
              // console.log('Response:',response?.data)
              if (response?.data?.status === 'success'){
                setAuthToken(null)
                setCurrentUser(null)
                localStorage.removeItem('MazGuardAuthToken')
                sessionStorage.removeItem('MazGuardCurrentUser')
                setLoading(false);
                navigate('/')
              }

            showSwalNotification({status:'success',message:'logout success'})
    
          } catch (error){
              console.error('Error Response:',error?.response?.data)
              
            // showSwalNotification(error.response.data)
          } finally{
            setLoading(false)
            // fetchStats()
            setAuthToken(null)
            setCurrentUser(null)
            localStorage.removeItem('MazGuardAuthToken')
            sessionStorage.removeItem('MazGuardCurrentUser')
            setLoading(false);
            navigate('/')
            showSwalNotification({status:'success',message:'logout success'})
          }
      }
    }
  

    // ==================GET LOGGED USER DETAILS ================
    
    const fetchUserDetails = async () => {
      if (!!authToken) {     

      try {
          const response = await axiosInstance.requestWithQueue({
              url: `${process.env.REACT_APP_SERVER_URL}/auth/user`,
              method: 'GET',
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
              }
          });
            // console.log(response?.data)
          if (response?.data?.status === 'success'){
            setCurrentUser(response?.data?.data);
            // fetchStats()
          }
          // console.log('Response', response?.data?.data);
      } catch (error) {
        console.error(error?.response?.data)
        setCurrentUser(null)
        setAuthToken(null)
        localStorage.removeItem('MazGuardAuthToken')
        sessionStorage.removeItem('MazGuardCurrentUser')
      }
    }
  };

  useEffect(() => {
      fetchUserDetails();
  }, [authToken]);
  

    // ================== CHANGE PASSWORD ================


    async function changePasword(password){
      if (authToken){
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/password/update`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:{password}
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } 
      }
    }



    // ================== RESET PASSWORD ================
    async function resetPassword(formData){
      // if (authToken){
          // console.log('Submited password:',password,sk)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/reset/password`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } 
      // }
    }


    // ================== RESET PASSWORD REQUEST ================
    async function resetPasswordRequest(data){
      if (!!data){
          // console.log('Submited password:',data)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/reset/request`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                data:data
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } 
      }
    }


    // ================== UPDATE USER STATUS(SUPPORT) ================
    async function updateUserStatus(formData){
      if (!!authToken && !!currentUser && currentUser?.role === 'support'){
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/update/account-status`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data: formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } 
      }
    }


    // ================== REGISTER ADMINS ================

    async function registerAdmin(formData){
      if (!!authToken && !!currentUser && currentUser?.role === 'admin'){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/register-admin`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data 
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              console.error(error?.response?.data)
          } finally {
              setLoading(false)
          }
        }
      }


    // ================== UPDATE PROFILE ================

    async function updateProfile(formData){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/update/profile`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data 
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              console.error(error?.response?.data)
          } finally {
              fetchUserDetails()
              setLoading(false)
          }
        }
      }


    // ================== FETCH ALL ADMINS ================

    async function fetchAllAdmins(){
      if (!!authToken && !!currentUser && ['specialist','support','admin'].includes(currentUser?.role)){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/auth/admins`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              setAllAdmins(response?.data?.data) 
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              console.error(error?.response?.data)
          } finally {
              setLoading(false)
          }
        }
      }
    
      useEffect(() => {
        // Fetch once immediately
        fetchAllAdmins();
      
        // Set interval to fetch every 5 minutes (300,000 ms)
        const intervalId = setInterval(() => {
          fetchAllAdmins();
        }, 5 * 60 * 1000); // 50 minutes
      
        // Cleanup on unmount
        return () => clearInterval(intervalId);
      }, [currentUser, authToken]);

      // ================== GET USER BY QUERY ================

      async function getUserByQuery(query){
        if (!!authToken){
            setLoading(true)
            try {
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/user/${query}`,
                  method:"GET",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`
                  }
                })
                return response?.data

            } catch (error){
                console.error(error?.response?.data)
            } finally {
                setLoading(false)
            }
        }
      }

      async function resendOTP(data){
        if (!!data){
            try {
                setLoading(true)
                const response = await axiosInstance.requestWithQueue({
                  url: `${process.env.REACT_APP_SERVER_URL}/auth/retry-otp`,
                  method:"POST",
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    // Authorization: `Bearer ${authToken}`
                  },
                  data: data
                })
                // console.log('Response:',response?.data)
                if (response?.data?.status === 'success'){
                  setAuthToken(response?.data?.data?.token);
                  // fetchStats()
                }
                return response?.data 
      
            } catch (error){
                // console.log('Error Response:',error?.response?.data)
                
              return error.response.data
            } finally{
              setLoading(false)
            }
        }
      }

      

    const contextData = {
      authToken,
        loading, setLoading,
        userLogin,userLogout,
        currentUser,
        fetchUserDetails,
        changePasword,
        resetPassword,
        resetPasswordRequest,
        updateUserStatus,
        userRegistration,
        adminLoginVerification,
        allAdmins, setAllAdmins,
        registerAdmin,updateProfile,
        userGoogleLogin,
        specialistRegistration,
        getUserByQuery,     
        resendOTP,   
    }
  return (
    <AuthContext.Provider value={contextData}>
        {children}
    </AuthContext.Provider>
  )
}
